{
  "home_page": {
    "header": {
      "title": "Welcome to SparkLayer"
    },
    "footer": "Learn more about SparkLayer"
  }
}
